import { point, bbox, featureCollection } from '@turf/turf';
import { getJobApplicationLocation, getSelectedVacancy } from '@App/components/Map/controls/RouteInfo/route-info.utils';
import { companyHasAddress } from '@services/utils.service';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

function fitBoundsCoords(map, points, bottom) {
  if (map) {
    map.fitBounds(bbox(featureCollection(points.map((p) => {
      return point(p);
    }))), {
      padding: {
        top: 50 + 100,
        bottom: bottom + 100,
        left: 100,
        right: 100,
      },
    });
  }
}

function createNearbyStopFeature(stop) {
  return {
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [stop.lon, stop.lat],
    },
    properties: {
      agency: stop.id.startsWith('1:') ? 'delijn' : 'nmbs',
      ...stop,
    },
  };
}

function useCurrentJobDestination(company, vacancyId) {
  const useJobApplicationLocation = useSelector(state => state.vacancy.useJobApplicationLocation);

  return useMemo(() => {
    if (!company) {
      return undefined;
    }

    const selectedVacancy = getSelectedVacancy(company.properties.vacancies, Number(vacancyId));

    if (useJobApplicationLocation) {
      return getJobApplicationLocation(selectedVacancy);
    }

    return companyHasAddress(company)
      ? { lat: company.geometry.coordinates[1], lng: company.geometry.coordinates[0] } : undefined;
  }, [company, useJobApplicationLocation, vacancyId]);
}

function setFietssnelwegenLowPrio(fietssnelwegen) {
  return fietssnelwegen.map((feature) => {
    return {
      ...feature,
      properties: {
        ...feature.properties,
        lowPro: true,
      },
    };
  });
}

function getStopsToShow(nearbyStops, stopsNearbyHomeAddress, stopsForMapBounds, mapZoom) {
  const stops = [];

  [...nearbyStops.delijn, ...nearbyStops.nmbs].forEach((stop) => {
    if (!stops.find(s => s.properties.id === stop.id)) {
      stops.push(createNearbyStopFeature(stop));
    }
  });

  [...stopsNearbyHomeAddress.delijn, ...stopsNearbyHomeAddress.nmbs].forEach((stop) => {
    if (!stops.find(s => s.properties.id === stop.id)) {
      stops.push(createNearbyStopFeature(stop));
    }
  });

  if (stopsForMapBounds && typeof stopsForMapBounds.forEach === 'function' && mapZoom >= 14) {
    stopsForMapBounds.forEach((stop) => {
      if (!stops.find(s => s.properties.id === stop.id)) {
        stops.push(createNearbyStopFeature(stop));
      }
    });
  }

  return stops;
}

export {
  createNearbyStopFeature,
  fitBoundsCoords,
  getStopsToShow,
  setFietssnelwegenLowPrio,
  useCurrentJobDestination,
};